import styled from 'styled-components';

import { Button } from '../style';

export const Callout = styled.div`
  background: #fff7e6;
  border-left: 3px solid #b45309;
  border-radius: 0 6px 6px 0;
  padding: 10px 12px;
  margin-top: 6px;
  font-family: 'Inter', sans-serif;
`;

export const Message = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #92400e;
  font-size: 0.8rem;
  margin: 0;

  svg {
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

export const ActionButton = styled(Button)`
  margin-top: 8px;
`;
